import type { CasaLeon3DSimPanels } from '../types.js';

const KITCHEN_SEED = [
  { id: 'K-104', table: 'Mesa 12', items: ['Bife 400g', 'Papas rústicas'], status: 'en parrilla', etaMin: 8 },
  { id: 'K-105', table: 'Mesa 4', items: ['Ñoquis crema', 'Ensalada mixta'], status: 'cocina', etaMin: 12 },
  { id: 'K-106', table: 'Barra 2', items: ['Hamburguesa CL', 'Limonada'], status: 'listo', etaMin: 0 },
];

const WA_SEED = [
  { from: 'María G.', text: '¿Tienen mesa para 4 a las 21?', bot: false, at: '20:41' },
  { from: 'Bot Casa León', text: '¡Hola! Sí, patio o salón. ¿Preferís horario 21:00 o 21:30?', bot: true, at: '20:41' },
  { from: 'Delivery CL', text: 'Pedido #882 en camino — ETA 25 min', bot: true, at: '20:38' },
];

let tick = 0;

export function initialSimPanels(): CasaLeon3DSimPanels {
  return {
    kitchenOrders: [...KITCHEN_SEED],
    whatsapp: [...WA_SEED],
    phone: { id: 'call-1', caller: 'Reserva — Carlos', reason: 'Mesa 6 personas viernes', state: 'ringing' },
    register: {
      open: true,
      salesToday: 284_500,
      queue: [
        { table: 'Mesa 8', total: 42_800, method: 'Mercado Pago' },
        { table: 'Mesa 3', total: 18_200, method: 'Efectivo' },
      ],
    },
  };
}

export function advanceSimPanels(prev: CasaLeon3DSimPanels): CasaLeon3DSimPanels {
  tick += 1;
  const kitchenOrders = prev.kitchenOrders.map((o, i) => {
    if (i === 0 && o.etaMin > 0) return { ...o, etaMin: o.etaMin - 1 };
    if (i === 0 && o.etaMin === 0) return { ...o, status: 'listo' };
    return o;
  });

  const whatsapp =
    tick % 5 === 0
      ? [
          {
            from: 'Cliente nuevo',
            text: '¿Abren mañana feriado?',
            bot: false,
            at: '20:45',
          },
          ...prev.whatsapp.slice(0, 4),
        ]
      : prev.whatsapp;

  let phone = prev.phone;
  if (tick % 7 === 3) {
    phone = { id: `call-${tick}`, caller: 'Proveedor verduras', reason: 'Confirmar entrega', state: 'ringing' };
  } else if (phone.state === 'ringing' && tick % 7 === 5) {
    phone = { ...phone, state: 'active' };
  } else if (phone.state === 'active' && tick % 7 === 6) {
    phone = { ...phone, state: 'ended' };
  }

  const register =
    tick % 9 === 0
      ? {
          ...prev.register,
          salesToday: prev.register.salesToday + 12_400,
          queue: prev.register.queue.slice(1),
        }
      : prev.register;

  return { kitchenOrders, whatsapp, phone, register };
}
